export const STATUS = {
  idle: 0,
  loading: 1,
  error: 3,
}
